import { queryAllWithin, queryOneWithin, touchElement } from 'lambda-dom'
import { prop, uniqBy } from 'ramda'

import { ClusteredMap } from '@app-components'
import { createWindowMarker, getCompanyLocations } from '@app-helpers'

export default class LocationForm {

    private readonly texts: HTMLInputElement[]
    private readonly selects: HTMLSelectElement[]
    private readonly reset: HTMLAnchorElement

    constructor(
        private readonly map: ClusteredMap,
        private readonly form: HTMLFormElement,
    ) {
        this.texts = queryAllWithin(form)('input[type=text]')
        this.selects = queryAllWithin(form)('select')
        this.reset = queryOneWithin(form)('a.reset')!
    }

    initialize() {
        this.form.addEventListener('submit', (e) => this.handleSubmission(e))
        this.reset.addEventListener('click', () => this.handleReset())

        for (const text of this.texts) {
            text.addEventListener('keypress', (e) => this.handleTextFieldKeyPress(e))
            text.addEventListener('blur', () => this.dispatchSubmitEvent())
        }
        for (const select of this.selects) {
            select.addEventListener('change', () => this.dispatchSubmitEvent())
        }
    }

    private handleTextFieldKeyPress(e: KeyboardEvent): void {
        if (e.key === 'Enter') {
            this.dispatchSubmitEvent()
        }
    }

    private handleReset(): void {
        this.clear()
        this.dispatchSubmitEvent()
    }

    private async handleSubmission(e: Event): Promise<void> {
        e.preventDefault()
        const locations = await getCompanyLocations(new FormData(this.form))

        if (! locations) {
            return
        }

        touchElement('#niche-technologies', (counter) => {
            counter.innerHTML = uniqBy(prop('windowTitle'), locations).length.toString()
        })

        touchElement('#location-count', (counter) => {
            counter.innerHTML = locations.length.toString()
        })

        const markers = locations.map(createWindowMarker)

        this.map.deleteMarkers()
        this.map.setMarkers(markers)
    }

    private clear(): void {
        for (const filter of this.selects) {
            filter.selectedIndex = 0
        }

        for (const text of this.texts) {
            text.value = ''
        }
    }

    private dispatchSubmitEvent(): void {
        this.form.dispatchEvent(new Event('submit'))
    }
}
